import React, { FC, useState } from 'react';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { APPLICATION_VIEW_BASE_VIEW, APPLICATION_VIEW_STEPS } from './ApplicationViewAsideMenu';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';
import { ApplicationViewConfirmModal } from './ApplicationViewConfirmModal';
import {
  fetchApplicationView,
  setApplicationViewData,
  setApplicationViewDataSubmit,
} from '../../store/merchnts/actions/application-view';
import { IAuthState } from '../../redux/AuthRedux';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from '../../../setup';
import { parseJwt } from '../../views/login/Login';
import { merchantActionTypes } from '../../store/merchnts/action-types';

interface Props {
  formik: any;
}
export const ApplicationViewSummaryFooter: FC<Props> = ({ formik }) => {
  const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
  const user = parseJwt(authUser.idToken);
  const mid = user?.['custom:mid'];
  const navigate = useNavigate();

  const { merchantState: {
    isConfirmAgreement,
    isApplicationViewDataSubmissionLoading,
    applicationViewData,
    isSavingApplicationViewDataLoading
  }, dispatch } = useMerchants();


  const [modalState, setModalState] = useState<IModalWindow>({
    isOpen: false
  });
  const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));

  const handleBackSuccess = (): void => {
    navigate(`/${APPLICATION_VIEW_BASE_VIEW}/${APPLICATION_VIEW_STEPS.BUSINESS_DETAILS}`);
  };

  const handleBack = async (isNext: boolean, handleSuccess: () => void): Promise<void> => {

    dispatch({ type: merchantActionTypes.SET_APPLICATION_DATA_TO_DEFAULT });

    await setApplicationViewData({
      dispatch,
      formik,
      mid,
      // acquisition: applicationViewData?.productInfo?.trafficAcquisition,
      fileList: [],
      owners: applicationViewData?.owners,
      isNext,
      handleSuccess
    });
  };

  const handleSuccess = (): void => {
    setModalState({
      isOpen: true,
      modalTitle: 'Application submitted',
      contentClassName: 'd-block',
      content: <ApplicationViewConfirmModal />
    });
  };

  const enableTermsAndConditions = !!applicationViewData?.merchantTermsAndConditionsUrl && !!applicationViewData?.termsAndConditionsUrl;

  return(
    <>
      <div className="d-flex align-items-center mt-10 justify-content-between">
        <ButtonComponent
          buttonType={BUTTON_TYPE.TRANSPARENT}
          onButtonClick={(): Promise<void> => handleBack(false, handleBackSuccess)}
          loading={isSavingApplicationViewDataLoading}
          additionalClass="w-100px"
        >
          <>
            <FontAwesomeIcon icon={faAngleLeft} width={12} />
            <span className="ms-2">Back</span>
          </>
        </ButtonComponent>

        <ButtonComponent
          buttonName="Submit"
          additionalClass="btn-sm w-100px"
          // type="submit"
          isDisabled={!isConfirmAgreement && !applicationViewData.contractAlreadySigned || isApplicationViewDataSubmissionLoading}
          onButtonClick={(): Promise<void> => setApplicationViewDataSubmit({ dispatch, id: mid, handleSuccess, enableTermsAndConditions })}
          loading={isApplicationViewDataSubmissionLoading}
        />
      </div>

      <ModalWindow
        {...modalState}
        onClose={async (): Promise<void> => {
          await fetchApplicationView({ dispatch, mid, formik });
          closeModal();
        }}
      />
    </>
  );
};
